// import '@aws-amplify/ui-react/styles.css';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Authenticator } from '@aws-amplify/ui-react';
import { RequireAuth } from './components/RequireAuth';
import { MainAppBar } from './components/MainAppBar';
import { Login } from './components/Login';
import { GenericLanding } from './components/pages/GenericLanding';
import { WatchPage } from './components/watch-races/WatchPage';
import { VideoAdmin } from './components/video-admin/VideoAdmin';
import { ViewerTop } from './components/pages/ViewerTop';
import { RacerProfiles } from './components/racer-profiles/RacerProfiles';
import { ManageProfile } from './components/racer-profiles/ManageProfile';
import { TelemetryStream } from './components/telemetry-stream/TelemetryStream';
import { GlobalProvider } from './components/GlobalState';
import TeamVitals from './components/telemetry-stream/TeamVitals';

function MyRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainAppBar />}>
          <Route
            index
            element={
              <RequireAuth>
                <GenericLanding />
              </RequireAuth>
            }
          />
          <Route
            path="/watch"
            element={
              <RequireAuth>
                <WatchPage />
              </RequireAuth>
            }
          />
          <Route
            path="/viewer"
            element={
              <RequireAuth>
                <ViewerTop />
              </RequireAuth>
            }
          />
          <Route
            path="/racer-profiles"
            element={
              <RequireAuth>
                <RacerProfiles />
              </RequireAuth>
            }
          />
          <Route
            path="/manage-profile"
            element={
              <RequireAuth>
                <ManageProfile />
              </RequireAuth>
            }
          />
          <Route
            path="/video-admin"
            element={
              <RequireAuth>
                <VideoAdmin />
              </RequireAuth>
            }
          />
          <Route
            path="/telemetry-stream/:username"
            element={
              <RequireAuth>
                <TelemetryStream />
              </RequireAuth>
            }
          />
          <Route
            path="/team-vitals"
            element={
              <RequireAuth>
                <TeamVitals />
              </RequireAuth>
            }
          />
        </Route>
        <Route path="/login" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  return (
    <Authenticator.Provider>
      <GlobalProvider>
        <MyRoutes />
      </GlobalProvider>
    </Authenticator.Provider>
  );
}

export default App;
